@use 'sass:math';

@import '../../global/style/nano-theme/base';

// ie 11 fixes ... maximum numbers we can place on the grid ... upping this number decreases performance a lot.
$max-grid-cols: 10;

@mixin grid($size: 1) {
  @at-root :host(.nano-grid-#{$size}) {
    --current-grid-size: 'grid size: #{$size}';
    --col-width: calc(#{math.div(100, $size)}% - var(--grid-col-gap));
    --repeat-width: calc(100% / #{$size});

    .grid {
      grid-template-columns: repeat(#{$size}, minmax(var(--col-width), 1fr));

      $current-column: 1;
      $current-row: 1;

      @for $i from 1 through ($max-grid-cols * 2) {
        @if $current-column > $size {
          $current-column: 1;
          $current-row: $current-row + 1;
        }
        $current-column: $current-column + 1;
      }
    }
  }
}

@mixin grid-spans {
  @for $i from 1 through $max-grid-cols {
    ::slotted(.nano-grid-col-start-#{$i}) {
      grid-column-start: #{$i} !important;
    }

    ::slotted(.nano-grid-row-start-#{$i}) {
      grid-row-start: #{$i} !important;
    }

    ::slotted(.nano-grid-col-span-#{$i}) {
      grid-column-end: span #{$i} !important;
    }

    ::slotted(.nano-grid-row-span-#{$i}) {
      grid-row-end: span #{$i} !important;
    }
  }
}

:host {
  /**
  * @prop --grid-col-gap: gap between all columns. Defaults to theme's global padding
  * @prop --grid-row-gap: gap between all rows. Defaults to theme's global padding
  */

  --grid-col-gap: #{$spacing-medium};
  --grid-row-gap: #{$spacing-medium};
  --current-grid-size: "'grid size: sm'";

  display: block;
  opacity: 0;
  transition: 0.2s ease opacity;

  .grid {
    /* autoprefixer: ignore next */
    display: grid;

    /* autoprefixer: ignore next */
    grid-gap: var(--grid-row-gap) var(--grid-col-gap);
    block-size: inherit;
    min-block-size: inherit;
  }
}

:host(.ready) {
  opacity: 1;
}

:host(.has-grid) {
  .grid {
    display: grid;

    @include grid-spans;
  }
}

:host([content-panel]:not([content-panel='false'])) {
  .grid {
    grid-template-rows: auto 1fr;
  }
}

:host([full-height]:not([full-height='false'])) {
  block-size: 100%;

  .grid {
    grid-template-rows: 1fr;
  }
}

:host([show-helper]:not([show-helper='false'])) {
  .grid {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      pointer-events: none;
      background-image:
        repeating-linear-gradient(
          to right,
          hsla(204, 80%, 72%, 0.25),
          hsla(204, 80%, 72%, 0.25) var(--col-width),
          transparent var(--col-width),
          transparent var(--repeat-width)
        );
      background-size: calc(100% + var(--grid-col-gap)) 100%;
      z-index: 100;
    }

    &::before {
      content: var(--current-grid-size);
      font-size: 30px;
      position: absolute;
      inline-size: 100%;
      inset-inline-start: 0;
      text-align: center;
      inset-block-start: 50%;
      transform: translateY(-50%);
      color: rgba(0, 0, 0, 0.2);
      text-transform: uppercase;
      z-index: 99;
      pointer-events: none;
    }
  }
}

@for $i from 1 through $max-grid-cols {
  @include grid($i);
}
